/*
  bfroz-vibes.js : port de l'état « activeIdx » de _source/src/components/VibesSection.tsx.
  Au survol d'une carte [data-vibe-card] (mouseenter / mouseleave, comme onMouseEnter / onMouseLeave),
  on applique EXACTEMENT les styles en ligne que React posait selon isActive :
    corps      : background-color accent | rgba(0, 30, 48, 0.78) ; box-shadow shadowGlow | 0 8px 30px rgba(0,0,0,0.35)
    nom        : color rgba(255,255,255,0.95) | rgba(255,255,255,0.7)
    vibe (h3)  : color #FFFFFF | accent
    fruit      : opacity 1 | 0 ; transform scale(1) | scale(0.5)
    tube       : src givré | normal ; height 260px | 240px ; transform translateY(-8px) rotate(-3deg) | translateY(0) rotate(0deg) ;
                 filter drop-shadow(0 20px 40px glow) | drop-shadow(0 8px 20px rgba(0,0,0,0.3))
    attributs  : opacity 0, height 0 | opacity 1, height auto
    tagline    : opacity 1, height auto | opacity 0, height 0
  Les durées viennent des classes du markup (transition-all duration-300/500/700). Un seul écouteur délégué.
*/
(function () {
  'use strict';

  var INACTIVE_BG = 'rgba(0, 30, 48, 0.78)';
  var INACTIVE_SHADOW = '0 8px 30px rgba(0,0,0,0.35)';
  var INACTIVE_NAME = 'rgba(255,255,255,0.7)';
  var ACTIVE_NAME = 'rgba(255,255,255,0.95)';
  var ACTIVE_TITLE = '#FFFFFF';

  function q(card, sel) {
    return card.querySelector(sel);
  }

  function setActive(card, active) {
    var accent = card.getAttribute('data-vibe-accent') || '';
    var glow = card.getAttribute('data-vibe-glow') || 'rgba(0,0,0,0.3)';
    var shadowGlow = card.getAttribute('data-vibe-shadow-glow') || INACTIVE_SHADOW;
    var tubeSrc = card.getAttribute('data-vibe-tube') || '';
    var frostSrc = card.getAttribute('data-vibe-tube-frost') || tubeSrc;

    var body = q(card, '[data-vibe-body]');
    var name = q(card, '[data-vibe-name]');
    var title = q(card, '[data-vibe-title]');
    var fruit = q(card, '[data-vibe-fruit]');
    var tube = q(card, '[data-vibe-tube]');
    var attributes = q(card, '[data-vibe-attributes]');
    var tagline = q(card, '[data-vibe-tagline]');

    if (body) {
      body.style.backgroundColor = active ? accent : INACTIVE_BG;
      body.style.boxShadow = active ? shadowGlow : INACTIVE_SHADOW;
    }
    if (name) name.style.color = active ? ACTIVE_NAME : INACTIVE_NAME;
    if (title) title.style.color = active ? ACTIVE_TITLE : accent;
    if (fruit) {
      fruit.style.opacity = active ? '1' : '0';
      fruit.style.transform = active ? 'scale(1)' : 'scale(0.5)';
    }
    if (tube) {
      var wanted = active ? frostSrc : tubeSrc;
      if (wanted && tube.getAttribute('src') !== wanted) tube.setAttribute('src', wanted);
      tube.style.height = active ? '260px' : '240px';
      tube.style.transform = active ? 'translateY(-8px) rotate(-3deg)' : 'translateY(0) rotate(0deg)';
      tube.style.filter = active ? 'drop-shadow(0 20px 40px ' + glow + ')' : 'drop-shadow(0 8px 20px rgba(0,0,0,0.3))';
    }
    if (attributes) {
      attributes.style.opacity = active ? '0' : '1';
      attributes.style.height = active ? '0' : 'auto';
    }
    if (tagline) {
      tagline.style.opacity = active ? '1' : '0';
      tagline.style.height = active ? 'auto' : '0';
    }
    card.setAttribute('data-vibe-active', active ? 'true' : 'false');
  }

  // Seule la carte elle-même compte (pas ses enfants) : mouseenter/mouseleave sur la carte ne se
  // déclenchent qu'en franchissant sa frontière, exactement comme onMouseEnter/onMouseLeave en React.
  function cardOf(e) {
    var t = e.target;
    return t && t.nodeType === 1 && t.hasAttribute('data-vibe-card') ? t : null;
  }
  function onEnter(e) {
    var card = cardOf(e);
    if (card) setActive(card, true);
  }
  function onLeave(e) {
    var card = cardOf(e);
    if (card) setActive(card, false);
  }

  // mouseenter/mouseleave ne remontent pas : écoute en phase de capture sur le document (un seul écouteur,
  // valable aussi pour les cartes re-rendues par l'éditeur de thème).
  document.addEventListener('mouseenter', onEnter, true);
  document.addEventListener('mouseleave', onLeave, true);

  // Repli clavier : le focus sur une carte-lien reproduit le survol.
  document.addEventListener('focusin', onEnter);
  document.addEventListener('focusout', onLeave);
})();
